import {Component, OnInit, Renderer2} from '@angular/core';
import {ApiService} from './api.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Observable, interval} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {BodyFieldToSave} from './bodyFieldToSave';
import {DatePipe} from '@angular/common';
import {$locationShim, $locationShimProvider} from '@angular/common/upgrade';
import {TranslateService} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  dashColor: string;
  backColor: string;
  squareColor: string;
  cardColor: string;
  sub: any;
  first = true;
  todayDate = new Date();
  OAUTHCODE: string;
  code: string;
  directMaskUsername = '';
  directMaskPassword = '';


  constructor(public translate: TranslateService, private route: ActivatedRoute, private router: Router, public apiService: ApiService,
              private renderer: Renderer2, private snackBar: MatSnackBar, private datePipe: DatePipe, private activatedRoute: ActivatedRoute, private http: HttpClient) {
    /*this.activatedRoute.queryParams.subscribe(params => {
        let code = params['code'];

        // console.log(code);// OUTPUT 1534
    });*/
    /*window.console.log = () => {
    };*/

    this.apiService.getStates().subscribe(states => {
      this.apiService.allStates = states;
    });
    /*this.http.get('assets/Assets.json').subscribe(data => {
      let jsonData: any;
      jsonData = data;
      this.apiService.dashColor = jsonData.DASH;
      this.apiService.backColor = jsonData.BACK;
      this.apiService.squareColor = jsonData.SQUARE;
      this.apiService.cardColor = jsonData.CARD;
    });*/
    this.apiService.getTheme().subscribe(data => {
      this.apiService.getUserInfo().subscribe(info => {
        this.apiService.userInfo = info;
        if (this.apiService.isLoggedIn()) {
          this.apiService.getBetUserSetting().subscribe(currentSetting => {
            if (currentSetting.error) {
              if (currentSetting.error === 'No user settings') {
                if (data[0]) {
                  this.apiService.setBetUserSetting(data[0].id).subscribe(us => {
                    this.dashColor = data[0].dash_color;
                    this.backColor = data[0].back_color;
                    this.squareColor = data[0].square_color;
                    this.cardColor = data[0].card_color;
                    this.apiService.dashColor = this.dashColor;
                    this.apiService.backColor = this.backColor;
                    this.apiService.squareColor = this.squareColor;
                    this.apiService.cardColor = this.cardColor;
                    this.renderer.setStyle(document.body, 'background', this.backColor);
                  });
                }

              } else {
                this.apiService.updateBetUserSetting(data[0].id).subscribe(us => {
                  this.dashColor = data[0].dash_color;
                  this.backColor = data[0].back_color;
                  this.squareColor = data[0].square_color;
                  this.cardColor = data[0].card_color;
                  this.apiService.dashColor = this.dashColor;
                  this.apiService.backColor = this.backColor;
                  this.apiService.squareColor = this.squareColor;
                  this.apiService.cardColor = this.cardColor;
                  this.renderer.setStyle(document.body, 'background', this.backColor);
                });
              }
            } else {
              this.dashColor = currentSetting[0].dash_color;
              this.backColor = currentSetting[0].back_color;
              this.squareColor = currentSetting[0].square_color;
              this.cardColor = currentSetting[0].card_color;
              this.apiService.dashColor = this.dashColor;
              this.apiService.backColor = this.backColor;
              this.apiService.squareColor = this.squareColor;
              this.apiService.cardColor = this.cardColor;
              this.renderer.setStyle(document.body, 'background', this.backColor);
            }
          });
        } else {
          this.dashColor = data[0].dash_color;
          this.backColor = data[0].back_color;
          this.squareColor = data[0].square_color;
          this.cardColor = data[0].card_color;
          this.apiService.dashColor = this.dashColor;
          this.apiService.backColor = this.backColor;
          this.apiService.squareColor = this.squareColor;
          this.apiService.cardColor = this.cardColor;
          this.renderer.setStyle(document.body, 'background', this.backColor);
        }
      });

    });
    this.sub = interval(2000)
      .subscribe((val) => {
        this.todayDate = new Date();
        // // console.log(localStorage.getItem('expires'));
        let expired = new Date(localStorage.getItem('expires'));
        if (this.todayDate > expired) {
          this.apiService.directMaskId = 'a440fe570a9645b8adbc3ddb425e4a65';
          this.apiService.isDirectMask = true;
          localStorage.setItem('isDirectMask', 'true');
          this.directMaskLogin('admin.tipico', '@#T1p1c0#@');
          this.apiService.setLoggedOut();
        }
      });
    if (this.apiService.isLoggedIn()) {
      this.sub = interval(10000)
        .subscribe((val) => {
          this.apiService.postTasksId().subscribe(value => {
            this.apiService.searchTaskWV2({
              skip: 0,
              take: 50,
              select: {
                items: [
                  '_id'
                ]
              },
              filter: {
                items: []
              },
              sort: {
                items: []
              },
              skipCount: false
            }).subscribe(tasksV2 => {
              if (this.first === true) {
                this.apiService.taskNumber = value.data.length;
                this.apiService.taskNumber += tasksV2.data.length;
                this.first = false;
              }
              let columnIdIndex;
              value.columns.forEach((col, index) => {
                if (col.id === 'ID') {
                  columnIdIndex = index;
                }
              });
              // // console.log('Task number ->' + this.apiService.taskNumber);
              // // console.log('Risultato chiamata -> ' + value.data.length);
              if (value.data.length > 0 || tasksV2.data.length > 0) {
                if (value.data.length + tasksV2.data.length > this.apiService.taskNumber.length) {
                  // // console.log('è entrato');
                  let newTask;
                  value.data.forEach(vd => {
                    let found = false;

                    this.apiService.taskNumber.forEach(tn => {
                      if (tn[columnIdIndex] === vd[columnIdIndex]) {
                        found = true;
                      }
                    });
                    if (!found) {
                      newTask = vd;
                    }
                  });
                  if (newTask) {
                    this.snackBar.open(this.translate.instant('advices.newTask'), this.translate.instant('advices.goToTask') + newTask[columnIdIndex], {
                      duration: 4500,
                      horizontalPosition: 'end',
                      verticalPosition: 'bottom',
                      panelClass: ['mat-toolbar', 'custom-info-bg']
                    }).onAction()
                      .subscribe(() => this.router.navigate
                      (['dashboard/dashnav/dettaglitask', {
                        id: newTask[columnIdIndex],
                        path: 'defaulthome',
                        isV2: false
                      }], {relativeTo: this.route}));
                  }
                  let newTaskV2;
                  tasksV2.data.forEach(vd => {
                    let found = false;

                    this.apiService.taskNumber.forEach(tn => {
                      if (tn[0] === vd[0]) {
                        found = true;
                      }
                    });
                    if (!found) {
                      newTaskV2 = vd;
                    }
                  });
                  if (newTaskV2) {
                    this.snackBar.open(this.translate.instant('advices.newTask'), this.translate.instant('advices.goToTask') + newTaskV2[0], {
                      duration: 4500,
                      horizontalPosition: 'end',
                      verticalPosition: 'bottom',
                      panelClass: ['mat-toolbar', 'custom-info-bg']
                    }).onAction()
                      .subscribe(() => this.router.navigate
                      (['dashboard/dashnav/dettaglitask', {id: newTaskV2[0], path: 'defaulthome', isV2: true}], {relativeTo: this.route}));
                  }
                  this.apiService.taskNumber = value.data.concat(tasksV2.data);
                } else {
                  this.apiService.taskNumber = value.data.concat(tasksV2.data);
                }
              } else {
                // // console.log(value.data.length);
                this.apiService.taskNumber = value.data.concat(tasksV2.data);
              }
            });

          });
        });
    }
  }

  TransformDataFormatToShow(Data: string): string {
    return this.datePipe.transform(Data, 'dd/MM/yyyy h:mm:ss', '', 'en-GB');
  }

  directMaskLogin(user: string, pass: string): void {

    this.apiService.login({
      languageCultureName: localStorage.getItem('lang'),
      username: user,
      password: pass,
      clientId: this.apiService.CLIENT_ID,
      clientSecret: this.apiService.CLIENT_SECRET
    }).subscribe(data => {
        this.apiService.isDirectMask = true;
        localStorage.setItem('isDirectMask', 'true');

        this.apiService.setLoggedInInformation(data);
        localStorage.setItem('username', this.directMaskUsername);
        localStorage.setItem('expires', data.expires);

        this.router.navigate(['directMaskRoute', {id: this.apiService.directMaskId, idTask: 0}]);


      },
      // tslint:disable-next-line:no-shadowed-variable
      error => {
        this.snackBar.open(error.error.userMessage, null, {
          duration: 2000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
          panelClass: ['mat-toolbar', 'custom-danger-bg']
        });
      });

  }

  ngOnInit(): void {

    if (localStorage.getItem('waitforcodedocu') === 'true') {
      this.activatedRoute.queryParams.subscribe(params => {
        this.code = params['code'];
        if (this.code !== undefined) {
          this.apiService.OAUTHCODE = this.code;
          localStorage.setItem('waitforcodedocu', 'false');
          if (localStorage.getItem('loggedIn')) {
            this.router.navigate(['dashboard']);
          } else {
            this.router.navigate(['login']);
          }
        }
      });
    } else if (localStorage.getItem('waitforcodegoogle') === 'true') {
      this.activatedRoute.queryParams.subscribe(params => {
        this.code = params.code;
        if (this.code !== undefined) {
          this.apiService.AUTHCODE = this.code;
          localStorage.setItem('waitforcodegoogle', 'false');
          if (localStorage.getItem('loggedIn')) {
            this.router.navigate(['dashboard']);
          } else {
            this.router.navigate(['login']);
          }
        }
      });

      /*if (localStorage.getItem('loggedIn')) {
          this.router.navigate(['dashboard']);
      } else {
          this.router.navigate(['login']);
      }*/
    } else {
      if (window.location.pathname.startsWith('/directMask')) {
        const match = window.location.pathname.match(/id=([a-f0-9]+)/); // http://localhost:4200/directMask;id=%%ID MASCHERA QUI%%;idTask=0
        // TIPIECO: a440fe570a9645b8adbc3ddb425e4a65
        if (match) {
          const idValue = match[1];
          // console.log("ID Value:", idValue);
          this.apiService.directMaskId = idValue;
          if (this.apiService.directMaskId === 'a440fe570a9645b8adbc3ddb425e4a65') {
            this.apiService.isDirectMask = true;
            localStorage.setItem('isDirectMask', 'true');
            this.directMaskLogin('admin.tipico', '@#T1p1c0#@');
          }
        } else {

        }

      } else {

        if (localStorage.getItem('loggedIn') && localStorage.getItem('isDirectMask') === 'false') {
          this.apiService.directMaskId = 'a440fe570a9645b8adbc3ddb425e4a65';
          this.apiService.isDirectMask = true;
          localStorage.setItem('isDirectMask', 'true');
          this.directMaskLogin('admin.tipico', '@#T1p1c0#@');
        } else {
          this.apiService.isDirectMask = false;
          this.apiService.setLoggedOut();
          this.apiService.directMaskId = 'a440fe570a9645b8adbc3ddb425e4a65';
          this.apiService.isDirectMask = true;
          localStorage.setItem('isDirectMask', 'true');
          this.directMaskLogin('admin.tipico', '@#T1p1c0#@');
        }
      }


    }
  }
}
